import { render } from "./EditQualificationMembership.vue?vue&type=template&id=056a0b79"
import script from "./EditQualificationMembership.vue?vue&type=script&lang=js"
export * from "./EditQualificationMembership.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__